import styled, { css } from "styled-components";
import { CardBodyContainer, Description, H1, ImageContainer } from "@evergis/ui";

const DarkCardsBlockMixin = css<{ $isDark?: boolean }>`
  ${CardBodyContainer} {
    background-color: ${({ theme: { palette } }) => palette.elementDark};
  }

  ${ImageContainer}:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${({ theme }) => theme.elementsArea.cardOverlayColor};
  }
`;

const LightCardsBlockMixin = css<{ $isDark?: boolean }>`
  :after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: ${({ theme: { elementsArea } }) => elementsArea.backgroundOverlayColor};
  }
`;

export const CardsBlock = styled.div<{ $isDark?: boolean }>`
  display: flex;
  flex: 1;
  min-width: 48rem;
  min-height: 15rem;
  padding: 2rem;
  background: ${({ theme: { elementsArea } }) => elementsArea.backgroundColor};
  overflow-x: hidden;
  overflow-y: auto;

  ${({ $isDark }) => ($isDark ? DarkCardsBlockMixin : LightCardsBlockMixin)}
`;

export const NoResourcesBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 1rem;

  & > * {
    margin: 1rem;
  }
`;

export const CenteredItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CardsError = styled.div`
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;

  svg {
    width: 3rem;
    min-height: 32px;
    margin-top: 3rem;
  }
  ${H1} {
    color: #8b8b8b;
    margin: 1rem 0 0 0;
    font-size: 1.5rem;
  }
  ${Description} {
    color: #8b8b8b;
    margin: 0 0 1rem 0;
    font-size: 1.3rem;
  }
`;
